/** @format — Parse non-stream /v1/agents batch JSON (multimodal fallback) */

import { normalizeAguiComponents } from "./normalizeComponents";

export function parseAgentResponseWithUi(responseData) {
  const body = responseData?.data !== undefined ? responseData.data : responseData;
  const root = body?.data !== undefined ? body.data : body;
  const text =
    typeof root?.response === "string"
      ? root.response
      : typeof root?.message === "string"
        ? root.message
        : typeof root?.text === "string"
          ? root.text
          : "No response received";

  const uiComponents = normalizeAguiComponents(
    root?.ui_components ??
      root?.uiComponents ??
      root?.generative_ui ??
      root?.generativeUi,
  );

  const payment_event =
    root?.payment_event ??
    body?.payment_event ??
    responseData?.payment_event ??
    null;

  return { text, uiComponents, payment_event };
}
